import tiers from '@/api/resellerTiers';

// reseller tiers
const APPEND_NEW_TIER = 'APPEND_NEW_TIER';
const APPEND_NEW_PRODUCT_TIER = 'APPEND_NEW_PRODUCT_TIER';
// const APPEND_TIERS = 'APPEND_TIERS';
const SET_TIERS = 'SET_TIERS';
const RESET_RESELLER_TIERS = 'RESET_RESELLER_TIERS';
const SET_PRODUCT_TIERS = 'SET_PRODUCT_TIERS';
const RESET_RESELLER_PRODUCT_TIERS = 'RESET_RESELLER_PRODUCT_TIERS';
const DELETE_RESELLER_TIERS = 'DELETE_RESELLER_TIERS';
const UPDATED_RESELLER_TIER_DATA = 'UPDATED_RESELLER_TIER_DATA';
const SET_IS_FETCHING = 'SET_IS_FETCHING';
const SET_IS_FETCHED = 'SET_IS_FETCHED';
const SET_PAGE = 'SET_PAGE';
const ADD_PAGE = 'ADD_PAGE';
const SET_IS_ALL = 'SET_IS_ALL';
const UPDATED_DISCOUNT_TYPE = 'UPDATE_DISCOUNT_TYPE';
const UPDATED_DISCOUNT_VALUE = 'UPDATE_DISCOUNT_VALUE';
const DELETE_RESELLER_PRODUCT_TIERS = 'DELETE_RESELLER_PRODUCT_TIERS';

const state = {
	all: [],
	isFetching: false,
	isFetched: false,
	isAll: false,
	page: 1,
	detail: '',
	productTiers: [],
};

const getters = {
	all: state => state.all,
	productTiers: state => state.productTiers,
	isFetching: state => state.isFetching,
	isFetched: state => state.isFetched,
	isAll: state => state.isAll,
	page: state => state.page,
	detail: state => state.detail,
	activitiesFetching: state => state.activitiesFetching,
	activitiesAll: state => state.activitiesAll,
	activitiesIsAll: state => state.activitiesIsAll,
	activitiesPage: state => state.activitiesPage,
	contactStat: state => state.contactStat,
	contactRegionStat: state => state.contactRegionStat,
	remindersAll: state => state.remindersAll,
	isFetchingReminder: state => state.isFetchingReminder,
	isReminderAll: state => state.isReminderAll,
	pageReminder: state => state.pageReminder,
	totalContactReminders: state => state.totalContactReminders,
	tags: state => state.tags,
	products: state => state.products,
};

const mutations = {
	[UPDATED_RESELLER_TIER_DATA](state, tier) {
		const tierIndex = state.all.findIndex(curr => curr._id === tier._id);
		// console.log(tierIndex);
		if (tierIndex !== -1) {
			state.all[tierIndex].name = tier.name;
			state.all[tierIndex].discount_type = tier.discount_type;
			state.all[tierIndex].discount_value = tier.discount_value;
			state.all[tierIndex].icon = tier.icon;
			// state.all[tierIndex].discount_max = tier.discount_max;
			state.all[tierIndex].auto_upgrade = tier.auto_upgrade;
			state.all[tierIndex].threshold_type = tier.threshold_type;
			state.all[tierIndex].threshold_value = tier.threshold_value;
			state.all[tierIndex].level = tier.level;
		}
	},
	[APPEND_NEW_TIER](state, tier) {
		const tiers = state.all;
		tiers.unshift(tier);
		state.all = tiers;
	},
	[SET_TIERS](state, tiers) {
		state.all = tiers;
	},
	[UPDATED_DISCOUNT_TYPE](state, payload) {
		state.productTiers[payload.index].discount_type = payload.val;
	},
	[UPDATED_DISCOUNT_VALUE](state, payload) {
		state.productTiers[payload.index].discount_value = payload.value;
	},
	[RESET_RESELLER_TIERS](state) {
		state.all = [];
		state.isAll = false;
		state.page = 1;
	},
	[SET_PRODUCT_TIERS](state, tiers) {
		state.productTiers = tiers;
	},
	[RESET_RESELLER_PRODUCT_TIERS](state) {
		state.productTiers = [];
	},
	[APPEND_NEW_PRODUCT_TIER](state, tier) {
		const tiers = state.productTiers;
		tiers.unshift(tier);
		state.productTiers = tiers;
	},
	[DELETE_RESELLER_TIERS](state, index) {
		state.all.splice(index, 1);
	},
	[DELETE_RESELLER_PRODUCT_TIERS](state, index) {
		state.productTiers.splice(index, 1);
	},
	[SET_IS_FETCHING](state, status) {
		state.isFetching = status;
	},
	[SET_IS_FETCHED](state, status) {
		state.isFetched = status;
	},
	[SET_PAGE](state, page) {
		state.page = page;
	},
	[ADD_PAGE](state) {
		state.page++;
	},
	[SET_IS_ALL](state, isAll) {
		state.isAll = isAll;
	},
};

const actions = {
	// cutomers
	updatedResellerTierData({ commit }, value) {
		commit(UPDATED_RESELLER_TIER_DATA, value);
	},
	getResellerTiers({ commit, getters }, params) {
		if (!getters.isFetching) {
			commit(SET_IS_FETCHING, true);
			const callback = (response) => {
				const tiers = response.data;

				if (getters.all.length === 0) {
					commit(SET_TIERS, tiers);
				} else if (tiers.length !== 0) {
					commit(APPEND_NEW_TIER, tiers);
				}

				if (tiers.length === 0) {
					commit(SET_IS_ALL, true);
				} else {
					commit(SET_IS_ALL, false);
				}

				commit(ADD_PAGE);
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_FETCHED, true);
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_ALL, true);
				commit(SET_IS_FETCHED, true);
			};
			tiers.getResellerTiers(params, callback, errorCallback);
		}
	},
	getResellerProductTiers({ commit }, id) {
		// commit(SET_IS_FETCHING, true);
		const callback = (response) => {
			const tiers = response.data;
			commit(SET_PRODUCT_TIERS, tiers);
			// commit(SET_IS_FETCHING, false);
			// commit(SET_IS_FETCHED, true);
		};
		const errorCallback = (e) => {
			// eslint-disable-next-line
			console.log(e);
			// commit(SET_IS_FETCHING, false);
			// commit(SET_IS_FETCHED, true);
		};
		tiers.getResellerProductTiers(id, callback, errorCallback);
	},
	resetResellerTiers({ commit }) {
		commit(RESET_RESELLER_TIERS);
	},
	resetResellerProductTiers({ commit }) {
		commit(RESET_RESELLER_PRODUCT_TIERS);
	},
	setPage({ commit }, value) {
		commit(SET_PAGE, value);
	},
	setIsAll({ commit }, isAll) {
		commit(SET_IS_ALL, isAll);
	},
	setAppendNewTier({ commit }, value) {
		commit(APPEND_NEW_TIER, value);
	},
	setAppendNewProductTier({ commit }, value) {
		commit(APPEND_NEW_PRODUCT_TIER, value);
	},
	delete({ commit }, index) {
		commit(DELETE_RESELLER_TIERS, index);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
